// Docs: https://www.instantdb.com/docs/permissions
// Auto-pushed to InstantDB by CI on changes to this file.

import type { InstantRules } from "@instantdb/react";

// Kept here (not imported from constants.ts) because the InstantDB CLI loads
// this file with jiti in a Node context during CI perms push, and cannot
// resolve constants.ts's Deno/JSR dependency graph. constants.ts re-exports
// this value so there is still a single source of truth.
export const superAdminEmail = "uri.valevski@gmail.com";

const rules = {
  "bots": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('admins.id')",
      "doesNotModifyServerFields",
      "request.modifiedFields.all(field, !(field in ['botId', 'agentRunCount', 'llmRunCount', 'imageGenerationCount', 'incomingMessageCount', 'promptTokenCount', 'candidatesTokenCount', 'thoughtsTokenCount', 'cachedContentTokenCount', 'billingPeriodStart', 'webhookSecret', 'remoteToolsSecret', 'viewChatGroupId', 'aliceAndBotCredentials', 'gmailHistoryId', 'slackBotUserId', 'telegramUsername']))",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "isAdminOfBot",
      "update": "isAdminOfBot && doesNotModifyServerFields",
    },
  },
  "$files": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
    ],
    "allow": {
      "view": "isLoggedIn",
      "create": "isLoggedIn",
      "delete": "false",
      "update": "false",
    },
  },
  "$users": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isSelf",
      "isLoggedIn && auth.id == data.id",
      "sharesBotAsAdmin",
      "isLoggedIn && auth.id in data.ref('bots.admins.id')",
      "doesNotModifyProtectedFields",
      "request.modifiedFields.all(field, !(field in ['billingPeriodStart', 'failedPaymentTimestamp', 'polarCustomerId', 'polarSubscriptionId', 'stripeCustomerId', 'stripeSubscriptionId', 'tier', 'agentRunCount', 'llmRunCount', 'imageGenerationCount', 'incomingMessageCount', 'promptTokenCount', 'candidatesTokenCount', 'thoughtsTokenCount', 'cachedContentTokenCount', 'email', 'phone', 'telegramId', 'signupIp', 'lastIp']) && (field != 'attribution' || data.attribution == null) && (field != 'signupTimestamp' || data.signupTimestamp == null))",
    ],
    "allow": {
      "view": "isSelf || sharesBotAsAdmin",
      "create": "isLoggedIn && doesNotModifyProtectedFields",
      "delete": "false",
      "update": "isSelf && doesNotModifyProtectedFields",
    },
  },
  "secrets": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "variables": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "contacts": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "isAdminOfBot",
      "update": "false",
    },
  },
  "files": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('folder.bots.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "isAdminOfBot",
      "delete": "isAdminOfBot",
      "update": "isAdminOfBot",
    },
  },
  "folders": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bots.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "isAdminOfBot",
      "delete": "isAdminOfBot",
      "update": "isAdminOfBot",
    },
  },
  "projects": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "ragDocuments": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('file.folder.bots.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "tasks": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "isAdminOfBot",
    },
  },
  "machines": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bots.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "envVariables": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "apiTokens": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isOwner",
      "isLoggedIn && auth.id in data.ref('user.id')",
    ],
    "allow": {
      "view": "isOwner",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "skills": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "whatsappBusinessAccounts": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "false",
    },
  },
  "whatsappBusinessNumbers": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isAdminOfBot",
      "isLoggedIn && auth.id in data.ref('businessAccount.bot.admins.id')",
    ],
    "allow": {
      "view": "isAdminOfBot",
      "create": "false",
      "delete": "false",
      "update": "isAdminOfBot",
    },
  },
  // Demo numbers are viewable by any logged-in user; only the super admin may
  // create/update/delete them.
  "demoNumbers": {
    "bind": [
      "isLoggedIn",
      "auth.id != null",
      "isSuperAdmin",
      `auth.email == '${superAdminEmail}'`,
    ],
    "allow": {
      "view": "isLoggedIn",
      "create": "isSuperAdmin",
      "delete": "isSuperAdmin",
      "update": "isSuperAdmin",
    },
  },
  // Only the super admin has any access to demoNumberTokens.
  "demoNumberTokens": {
    "bind": [
      "isSuperAdmin",
      `auth.email == '${superAdminEmail}'`,
    ],
    "allow": {
      "view": "isSuperAdmin",
      "create": "isSuperAdmin",
      "delete": "isSuperAdmin",
      "update": "isSuperAdmin",
    },
  },
} satisfies InstantRules;

export default rules;
